<build-section [contentOnly]="true"
               [contentExtraClass]="'w-100'">
  <div class="d-flex justify-content-lg-between flex-column flex-lg-row">
    <div class="upsell-variants order-1">
      <ng-container *ngIf="headerTpl; else defaultHeaderTpl">
        <ng-container *ngTemplateOutlet="headerTpl; context: { $implicit: mappedProduct, mappedProduct: mappedProduct, upsellProductType: upsellProductType }"></ng-container>
      </ng-container>

      <ng-template #defaultHeaderTpl>
        <div class="fw-super-bold font-2xl">
          {{ mappedProduct.name }}
        </div>
      </ng-template>

      <upsell-min-quantity
        class="d-block mt-2"
        *ngIf="upsellProductType?.minQuantity > 1 || maxQuantity !== null || stockLeft !== null || dailyLimit !== null"
        [minQuantity]="upsellProductType.minQuantity"
        [maxQuantity]="maxQuantity"
        [stockLeft]="stockLeft"
        [dailyLimit]="dailyLimit"
        [count]="getVariantsCount()"
        [unitKey]="upsellProductType.sizes[0].details?.unit?.key"
      ></upsell-min-quantity>

      <div class="font-sm text-muted mt-2"
           *ngIf="mappedProduct.description"
           [innerHTML]="mappedProduct.description"></div>

      <div class="mt-4">
        <div class="variant-counter-item d-flex" *ngFor="let variant of mappedProduct.variants">
          <ui-multiple-variants-counter
            class="me-3"
            [step]="mappedProduct.increment"
            [minCount]="mappedProduct.variants.length === 1 ? upsellProductType.minQuantity : 0"
            [minCountPerProduct]="upsellProductType.minQuantityPerProduct"
            [count]="variant.count"
            [size]="'xs'"
            [isPlusDisabled]="disablePlus"
            [btnHighlighting]="variant.count > 0"
            [debounceTimeCount]="100"
            [calcProductCount]="calcProductCountWrapper(variant.count || 0)"
            (onCountUpdated)="countUpdated(variant, $event)"
          ></ui-multiple-variants-counter>

          <div class="w-100">
            <div>
              <span class="fw-bold">{{ variant.name }}</span>
              <span>, {{ variant.price | tryToDiscountPrice: upsellProductType.discount?.value: currency }}</span>
              <i class="variant-image-icon icon-upload-images text-primary ms-2"
                 *ngIf="variant.image"
                 [imagePreviewTrigger]="variant.image.original"></i>
            </div>

            <div class="font-sm text-muted mt-1"
                 *ngIf="variant.description"
                 [innerHTML]="variant.description">
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="upsell-product-image order-0 order-lg-1 mb-md-max-3"
         *ngIf="mappedProduct.image">
      <img class="pointer"
           [src]="mappedProduct.image | multiUrlImage: 'original' : ''"
           [imagePreviewTrigger]="mappedProduct.image.original">
    </div>
  </div>
</build-section>

<common-addons-section
  *ngIf="addonsAvailable && sortingAddons.length"
  [sortingAddons]="sortingAddons"
  [cartLine]="addonsCartLine"
  [currency]="currency"
  [printingPictureMap]="printingPictureMap"
  [isPiecesWithMultipleVariants]="true"
  (onPrintingPictureSelected)="onPrintingPictureSelected($event)"
  (onExtraProductSelected)="onExtraProductSelected($event)"
  (onQuestionAnswerChange)="onQuestionAnswerChange($event)"
></common-addons-section>
